import FeaturedProducts from '@/components/Home/FeaturedProducts';
import Hero from '../components/Home/Hero';
import WhyChoose from '@/components/Home/WhyChoose';
import OurPartners from '@/components/Home/OurPartners';
import BookAppointment from '@/components/Home/BookAppointment';

export default function Home() {
  return (
    <>
      <Hero />
      <FeaturedProducts />
      <WhyChoose />
      <OurPartners />
      <BookAppointment />
    </>
  );
}
